import React from 'react';
import { useNavigate } from 'react-router';
import { Button } from '@/components/Button';
import type { PaymentOption } from '@/types/components';
import { ROUTE_SUBSCRIPTION_CHECKOUT } from '@/router/routes';
import { BorderRadius, ButtonVariant, Size } from '@/types/components';
import { PlanChip } from '@/pages/Subscription/PlanChip';
import { PlanPrice } from '@/pages/Subscription/PlanPrice';

interface Props {
  option: PaymentOption;
}

export const PaymentOptionCard: React.FC<Props> = ({ option }) => {
  const navigate = useNavigate();

  const goToCheckout = () =>
    navigate(ROUTE_SUBSCRIPTION_CHECKOUT, { state: { type: option.type } });

  return (
    <div className="flex h-full flex-col justify-between gap-6 rounded-xl bg-card p-4 shadow-card md:min-h-80 md:rounded-2xl md:p-6">
      <div className="flex flex-col gap-2 md:gap-4">
        <div className="flex flex-row-reverse items-start justify-between gap-2 md:flex-col md:items-start md:gap-6">
          <PlanChip type={option.type} label={option.label} />
          <PlanPrice option={option} />
        </div>
        <div className="flex flex-col">
          <p className="text-[18px]/[24px] font-semibold text-subtle-foreground md:text-[20px]/[28px] md:font-medium">
            {option.title}
          </p>
          {option.subtitle && (
            <p className="text-body-14 text-subtle-foreground">
              {option.subtitle}
            </p>
          )}
        </div>
      </div>
      <Button
        variant={ButtonVariant.Primary}
        size={Size.Large}
        radius={BorderRadius.Pill}
        className="w-full leading-5"
        onClick={goToCheckout}
      >
        {option.buttonLabel}
      </Button>
    </div>
  );
};
